import React from 'react';
import { useZxing } from 'react-zxing';
import { useFindInventory } from '../../../hooks/useInventory';

export default function Scan({ scan, search, setSearch }) {
  const find = useFindInventory();

  // scanner success, persist inventory id to state and hit API for it
  const onResult = result => {
    find.mutate(parseInt(result.text));
    setSearch(null);
  }

  // scanner failed
  // NOTE: scanner is ALWAYS running, and every tick it doesn't see a barcode is considered an error
  // as a result uncommmenting this is largely useless as it just fills the console with noise
  // leaving here just in case
  const onError = error => {
    //console.log(error);
  }

  // zxing scanner ref passed to video tag
  const { ref } = useZxing({
    onDecodeResult(result) {
      onResult(result);
    },
    paused: search !== scan
  })

  return (
    <div className="mt-1 has-text-centered" style={{ display: search === scan ? 'block' : 'none' }}>
      <video ref={ref} width="100%" height="200" className="p-2" style={{ border: '1px solid #CCCCCC' }} />
    </div>
  )
}
